import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetHoliday, doSaveHoliday } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import HolidayParamDiv from './HolidayParamDiv'
class HolidayManagementDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetHoliday(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetHoliday = (id) => {
        const { dispatch } = this.props
        dispatch(doGetHoliday({
            id: id || 0,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        dispatch(doSaveHoliday({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.doGetHoliday(id)
                }
            }
        }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        return Object.keys(changedValues基本信息).length > 0
    }

    handleAddParam = () => {
        const { optionsParas } = this.state
        const { list } = Tyan.utility.getListItems(this, '基本信息', '假期参数')
        Tyan.pubForm.showDialog('假期参数', props => <HolidayParamDiv {...props} initValues基本信息={{ '输入方式': '1' }}
            optionsParas={optionsParas}
            onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                const { 参数名称 } = changedValues
                if (参数名称) {
                    if (list.filter(o => 参数名称 == o.参数名称).length) {
                        Tyan.pubForm.showError('参数名称重复，请确认！')
                        return
                    }
                }
                addListItem(this, { ...changedValues }, '基本信息', '假期参数')
                onClose && onClose()
            }} />
        )
    }

    fieldset基本信息 = () => {
        return [
            { _text: '假期名称', minWidth: '95%', disabled: true },
            { _number: '假期单位', minWidth: '10%', },
            { _radio: '', name: '时长单位', optionName: '时长单位', minWidth: '25%', },
            { _number: '最小假期数量', minWidth: '45%', flex: 2, },
            { _radio: '假期类型', minWidth: '45%' },
            { _radio: '假期时段', minWidth: '45%' },
            { _text: '政策说明', minWidth: '90%', maxRows: 4, },
        ]
    }

    fieldset假期参数 = () => {
        const { optionsParas } = this.state
        return [{
            _grid: '', name: '假期参数', rowNumbers: true, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '参数名称', flex: 5 },
                { _text: '输入方式', flex: 2 },
                { _text: '输入选项', flex: 2 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handleAddParam, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('假期参数', props => <HolidayParamDiv {...props} initValues基本信息={{ ...data }}
                    optionsParas={optionsParas}
                    onConfirm={(changedValues, typesOfchangedValues, onClose) => {
                        const { 参数名称 } = changedValues
                        if (参数名称) {
                            if (list.filter(o => o.id !== data.id && 参数名称 == o.参数名称).length) {
                                Tyan.pubForm.showError('参数名称重复，请确认！')
                                return
                            }
                        }
                        changeListItem(this, changedValues, typesOfchangedValues, '基本信息', '假期参数', data.id)
                        onClose && onClose()
                    }}
                    onDelete={() => deleteListItem(this, '基本信息', '假期参数', data.id)}
                />)
            }
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '假期信息', name: '基本信息', _fieldset: this.fieldset基本信息(), /* docked: 'top', height: '68%'  */},
                    // { title: '假期参数', name: '基本信息', _fieldset: this.fieldset假期参数(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(HolidayManagementDetail)